var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"4"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.initAuthenticate.apply(null, arguments)}}},[_vm._v(" Authenticate App ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }